import { useNavigate } from "react-router-dom";

import pagenotfound from "../../../Image/pagenotfound.png";
import { Box, Button, Typography } from "@mui/material";
export const GCPageNotFound = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        textAlign: "center",
      }}
    >
      <div className="image-container">
        <img src={pagenotfound} alt="" />
      </div>

      <Typography
        className={"PageNotFound-font"}
        gutterBottom
        sx={{
          color: "primary.light",
        }}
      >
        The page you are looking for does not exist.
      </Typography>
      <Button
        variant="contained"
        onClick={() => {
          navigate("/");
        }}
      >
        Back Home
      </Button>
    </Box>
  );
};
